import React, { Component, Suspense } from "react";
import DocumentFactory from "./factories/DocumentFactory";
import { renderTitleModal } from "./utils/documentTitle";
import $ from 'jquery';
import ConfirmModal from "../confirmModal";

export default class DocumentModal extends Component {
    closeModalCreate = async () => {
        const { action, CloseDocumentModal } = this.props
        if (action === 1) {
            $('#confirmModal').modal('show');
        } else {
            await CloseDocumentModal();
        }
    };
    render() {
        const { CloseDocumentModal } = this.props

        const config = DocumentFactory.create(this.props);

        return (
            <div
                className="modal fade bd-example-modal-xl modal-open scroll show"
                style={{ display: "block", zIndex: 90 }}
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <ConfirmModal
                    CloseDocumentModal={CloseDocumentModal}
                />
                <div className="modal-dialog modal-xl modal-open modalOrder" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h5 className="modal-title">{renderTitleModal(this.props)}</h5>
                            <button type="button" className="close" onClick={this.closeModalCreate} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <Suspense fallback={<div>Cargando documento...</div>}>

                                {config.Header && <config.Header {...this.props} />}
                                {config.Items && <config.Items {...this.props} />}
                                {config.Summary && <config.Summary {...this.props} />}


                            </Suspense>
                        </div>
                        <div className="modal-footer">
                            <button
                                id="btnCloseDocumentModal"
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModalCreate}>
                                Cerrar
                            </button>
                            <Suspense fallback={<div>Cargando...</div>}>
                                {config.Footer && <config.Footer {...this.props} />}
                            </Suspense>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}